import { executeReport, REPORT_TYPES } from '../../../../../../../../../../../logic/utils/reportRequest';

export default async function SqlQuery(startTime, endTime) {
  // Получаем данные через новый API
  const result = await executeReport(REPORT_TYPES.GENERAL_DOUGHNUT_QUEUE, { startTime, endTime });

  // Возвращаем в том же формате - dataObjects уже имеют числовые индексы
  return { dataObjects: result.dataObjects, query: result.query };
}
